import React from "react";

export function StatusDot({ status }) {
    const map = {
        online: "bg-emerald-500",
        deployed: "bg-emerald-500",
        offline: "bg-red-500",
        error: "bg-red-500",
        deploying: "bg-amber-500 animate-pulse-dot",
        running: "bg-amber-500 animate-pulse-dot",
        success: "bg-emerald-500",
        failed: "bg-red-500",
        active: "bg-emerald-500",
        inactive: "bg-zinc-400",
        unknown: "bg-zinc-400",
    };
    return <span className={`dot ${map[status] || "bg-zinc-400"}`} />;
}

const LABELS = {
    online: "online",
    offline: "offline",
    deploying: "deploying",
    deployed: "deployed",
    error: "error",
    unknown: "unknown",
    running: "running",
    success: "success",
    failed: "failed",
    active: "active",
    inactive: "inactive",
};

export function StatusBadge({ status }) {
    return (
        <span className="inline-flex items-center gap-1.5 text-xs font-medium text-zinc-700">
            <StatusDot status={status} />
            <span className="font-mono">{LABELS[status] || status || "unknown"}</span>
        </span>
    );
}

export function RoleBadge({ role }) {
    const cfg = {
        ru_relay: { label: "RU RELAY", cls: "bg-zinc-100 text-zinc-800 border-zinc-200" },
        foreign_exit: { label: "FOREIGN EXIT", cls: "bg-orange-50 text-orange-700 border-orange-200" },
        standalone: { label: "STANDALONE", cls: "bg-blue-50 text-blue-700 border-blue-200" },
    };
    const c = cfg[role] || { label: role, cls: "bg-zinc-100 text-zinc-800 border-zinc-200" };
    return (
        <span className={`inline-flex items-center border rounded-sm px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${c.cls}`}>
            {c.label}
        </span>
    );
}
